import * as actionTypes from "../action-types";
import { put, takeLeading } from 'redux-saga/effects';
import { getAPI } from '../../utils/api-function';
import { get_partner_details, get_reports } from '../../utils/api-routes';

function* getPartnerDetails(action) {
    const { payload } = action;
    try {
        yield put({ type: actionTypes.SET_IS_LOADING, payload: true });
        const { data } = yield getAPI(get_partner_details(payload));
        console.log("Get Reports Saga Response ::: ", data);

        if (data?.status) {
            yield put({ type: actionTypes.SET_PARTNER_DETAILS, payload: data?.result });
        } else {
            yield put({ type: actionTypes.SET_PARTNER_DETAILS, payload: '' });
        }
        yield put({ type: actionTypes.SET_IS_LOADING, payload: false });

    } catch (error) {
        yield put({ type: actionTypes.SET_IS_LOADING, payload: false });
        console.log("Get Reports Saga Error ::: ", error);
    }
};

export default function* partnerSaga() {
    yield takeLeading(actionTypes.GET_PARTNER_DETAILS, getPartnerDetails);
};